<template>
  <!-- Footer Start -->
  <footer
    class="footer bg-dark-footer relative text-gray-200 dark:text-gray-200"
  >
    <div class="container py-[30px] px-0 border-t border-slate-800">
      <div class="container text-center">
        <div
          class="grid lg:grid-cols-12 md:grid-cols-3 grid-cols-1 items-center"
        >
          <div class="lg:col-span-3 md:text-start text-center">
            <a href="#" class="text-[22px] focus:outline-none">
              <img
                src="../assets/images/logo-light.png"
                class="mx-auto md:me-auto md:ms-0"
                alt=""
              />
            </a>
          </div>

          <div class="lg:col-span-5 text-center mt-6 md:mt-0">
            <!-- <p class="mb-0">© {{ date }} Dennis. Design & Develop with <i class="mdi mdi-heart text-red-600"></i> by <a href="https://shreethemes.in/" target="_blank" class="text-reset">Shreethemes</a>.</p> -->
            <p class="mb-0">
              © {{ date }} Designed by Koorosh Jalali Farahani.
            </p>
          </div>

          <ul
            class="lg:col-span-4 list-none md:text-end text-center mt-6 md:mt-0"
          >
            <!-- <li class="inline"><a href="https://dribbble.com/shreethemes" target="_blank" class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-amber-500 dark:hover:border-amber-500 hover:bg-amber-500 dark:hover:bg-amber-500"><i class="uil uil-dribbble align-middle" title="dribbble"></i></a></li>
                            <li class="inline"><a href="https://www.behance.net/shreethemes" target="_blank" class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-amber-500 dark:hover:border-amber-500 hover:bg-amber-500 dark:hover:bg-amber-500"><i class="uil uil-behance" title="Behance"></i></a></li> -->
            <li class="inline">
              <a
                href="https://www.linkedin.com/in/koorosh-jalali-farahani/"
                target="_blank"
                class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-amber-500 dark:hover:border-amber-500 hover:bg-amber-500 dark:hover:bg-amber-500"
                ><i class="uil uil-linkedin" title="Linkedin"></i
              ></a>
            </li>
            <li class="inline">
              <a
                href="https://www.facebook.com/koorosh.jalalifarahani"
                target="_blank"
                class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-amber-500 dark:hover:border-amber-500 hover:bg-amber-500 dark:hover:bg-amber-500"
                ><i class="uil uil-facebook-f align-middle" title="facebook"></i
              ></a>
            </li>
            <li class="inline">
              <a
                href="https://www.instagram.com/kookijalali/"
                target="_blank"
                class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-amber-500 dark:hover:border-amber-500 hover:bg-amber-500 dark:hover:bg-amber-500"
                ><i class="uil uil-instagram align-middle" title="instagram"></i
              ></a>
            </li>
            <!-- <li class="inline"><a href="https://twitter.com/shreethemes" target="_blank" class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-amber-500 dark:hover:border-amber-500 hover:bg-amber-500 dark:hover:bg-amber-500"><i class="uil uil-twitter align-middle" title="twitter"></i></a></li> -->
            <li class="inline">
              <a
                href="mailto:koorosh@truepts.net"
                class="btn btn-icon btn-sm border border-gray-800 rounded-md hover:border-amber-500 dark:hover:border-amber-500 hover:bg-amber-500 dark:hover:bg-amber-500"
                ><i class="uil uil-envelope align-middle" title="email"></i
              ></a>
            </li>
          </ul>
          <!--end icon-->
        </div>
        <!--end grid-->
      </div>
      <!--end container-->
    </div>
  </footer>
  <!--end footer-->
  <!-- Footer End -->
</template>

<script>
export default {
  name: 'footerComp',
  data() {
    return {
      date: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped></style>
